import "antd/lib/popover/style";
import _Popover from "antd/lib/popover";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import { jsxs as _jsxs } from "react/jsx-runtime";
import "antd/lib/avatar/style";
import _Avatar from "antd/lib/avatar";
import { jsx as _jsx } from "react/jsx-runtime";
import Loading from 'components/layout/Loading';
import React, { useMemo, useState } from 'react';
import ServiceBriefs from 'services/ServiceBriefs';
import BriefIcon from './BriefIcon';

var LanguagesPopover = function LanguagesPopover(_ref) {
  var translation = _ref.translation,
      briefUUID = _ref.briefUUID,
      onTranslatation = _ref.onTranslatation,
      children = _ref.children;

  var _useState = useState([]),
      languages = _useState[0],
      setLanguages = _useState[1];

  var _useState2 = useState(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var onVisibleChange = function onVisibleChange(visible) {
    if (visible) {
      getLanguages();
    }
  };

  var getLanguages = function getLanguages() {
    if (!languages.length) {
      setLoading(true);
      return ServiceBriefs.supportedLanguages().then(setLanguages)["finally"](function () {
        return setLoading(false);
      });
    }
  };

  var translateBrief = function translateBrief(lang) {
    setLoading(true);
    return ServiceBriefs.translate({
      briefUUID: briefUUID,
      lang: lang.code
    }).then(function (translation) {
      onTranslatation(translation);
    })["finally"](function () {
      return setLoading(false);
    });
  };

  var currLanguage = useMemo(function () {
    return translation.languageCode;
  }, [translation]);
  var languagesVisible = useMemo(function () {
    return languages.filter(function (lang) {
      return lang.code !== currLanguage;
    });
  }, [languages, currLanguage]);
  return /*#__PURE__*/_jsx(_Popover, {
    title: "Choose new Language",
    overlayClassName: "speakerPopover",
    onVisibleChange: onVisibleChange,
    placement: "right",
    trigger: "click",
    content: /*#__PURE__*/_jsx(Loading, {
      spinning: loading,
      children: /*#__PURE__*/_jsx(_Space, {
        size: 20,
        children: languagesVisible.map(function (lang) {
          return /*#__PURE__*/_jsx("div", {
            onClick: function onClick() {
              return translateBrief(lang);
            },
            className: "speakerFlag ".concat(currLanguage === lang.code ? 'current' : ''),
            children: /*#__PURE__*/_jsxs(_Space, {
              direction: "vertical",
              children: [/*#__PURE__*/_jsx(_Avatar, {
                size: "small",
                src: "/flags/".concat(lang.code, ".svg")
              }), /*#__PURE__*/_jsx("div", {
                className: "speakerLang",
                children: lang.code
              })]
            }, 'space' + lang.name)
          }, lang.name);
        })
      })
    }),
    children: children ? /*#__PURE__*/_jsxs("div", {
      children: [" ", children]
    }) : /*#__PURE__*/_jsx(BriefIcon, {
      icon: "World",
      title: "Choose new language"
    })
  });
};

export default LanguagesPopover;